// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"47156001","237":"d571e1d6","904":"0b45eb22"}[chunkId] + ".chunk.js";
};